import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedAdmin() {
  const token = localStorage.getItem("admin_token");

  if (!token) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}